<template>
    <div id="ContractAssetDetailCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="contractAssetDetailHeader" v-if="$route.params.id > 0">Update Contract Asset Detail</span>
                    <span class="page-title" id="contractAssetDetailHeader" v-else>Add Contract Asset Detail</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackContractAssetDetailList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="ContractAssetDetailForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <div class="custom-checkbox">
                                            <div class="form-check">
                                                <label class="checkbox-custom">
                                                    Allow Substitute
                                                    <input type="checkbox" v-model="allow_substitute" id="allow_substitute" name="allow_substitute">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="custom-checkbox">
                                    <div class="form-check">
                                        <label class="checkbox-custom">
                                            CPI Waived
                                            <input type="checkbox" v-model="cpi_waived" id="cpi_waived" name="cpi_waived" @input="cpi_waived_change(cpi_waived)">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="contract_id">Contract:</label>
                                        <v-select :disabled="close" v-model="contract_id" name="contract_id" id="contract_id"
                                            label="text" :filterable="false" :options="contractArr"
                                            @search="onSearchContract"
                                            placeholder="Select Contract Code" class="custom-ci-auto-search contract-data" @input="onContractSelect">
                                            <template slot="no-options">
                                                Search Contract...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ contract_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id" placeholder="Select Customer" label="text"
                                        :options="customerArr">
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle_id">Asset:</label>
                                        <v-select v-model="vehicle_id" name="vehicle_id" :disabled="close"
                                            label="text" :filterable="false" :options="vehicleArr"
                                            @search="onSearchVehicle"
                                            v-on:change="changeAssetsSelection(vehicle_id)"
                                            placeholder="Select Asset" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="po">PO:</label>
                                        <!-- <a href="javascript:void(0)" v-on:click="addNewPo()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add PO</a> -->
                                        <v-select v-model="po" name="po"
                                                label="text" :filterable="false" :options="poArr"
                                                @search="onSearchPO"
                                                placeholder="Select PO" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search PO...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error" id="customererror">{{ customer_po_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Effective Date:</label>
                                        <div class="input-group">
                                            <date-picker :disabled="close" placeholder="MM/DD/YYYY" @dp-change="onStartChange" id="effective_date" @input="changeEffectiveDate(effective_date), getCPIDetails('effective_date')" name="effective_date" v-model="effective_date" :config="fromOptionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{effective_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="term">Term:</label>
                                        <input type="text" class="form-control" v-model="term" id="term" @input="onChangeTerm(term)" placeholder="Enter Term" name="term">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Expiry Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="expiry_date" @dp-change="onEndChange" v-model="expiry_date" @input="onChangeExpiry(expiry_date)" :config="toOptionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="expiry_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{expiry_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="'control-label '+ firstEscalationRequired">First Escalation Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="first_escalation_date" :disabled="cpi_waived" name="first_escalation_date" v-model="first_escalation_date" :config="optionsDate" @input="onChangeFirstEsc(first_escalation_date)" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="first_escalation_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{first_escalation_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="term">Customer Unit Number:</label>
                                        <input type="text" class="form-control" v-model="unit_no" id="unit_no" placeholder="Enter Unit Number" name="unit_no">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="term">Schedule A Original Value ($):</label>
                                        <input type="text" class="form-control text-right"
                                        v-model="schedule_original_value"
                                        @blur="schedule_original_value = leaveFocus($event)"
                                        @focus="schedule_original_value = enterVal($event)"
                                        id="schedule_original_value"
                                        placeholder="Enter Original Value" @keypress="isNumber($event)" name="schedule_original_value">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="term">Schedule A Monthly Depreciation ($):</label>
                                        <input type="text" class="form-control text-right"
                                        @blur="schedule_depreciation = leaveFocus($event)"
                                        @focus="schedule_depreciation = enterVal($event)" v-model="schedule_depreciation" id="schedule_depreciation" placeholder="Enter Depreciation" @keypress="isNumber($event)" name="schedule_depreciation">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="term">Residual:</label>
                                        <input type="text" class="form-control text-right"
                                        v-model="residual" id="residual" placeholder="Enter Residual" @keypress="isNumber($event)" name="residual">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="term"> Excess Mileage Variation Allowed(%):</label>
                                        <input type="text" class="form-control"
                                        v-model="exmilevariation" id="exmilevariation" placeholder="Enter Excess Mileage Variation" @keypress="isNumber($event)" name="exmilevariation">
                                        <div class="field-error">{{excess_mileage_variation_error_msg}}</div>
                                    </div>
                                    <div class="col form-group" v-if="!cpi_waived">
                                        <label class="control-label require" for="term"> Base Index Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="base_index_date" name="base_index_date"  v-model="base_index_date" @input="getCPIDetails('base_index_date')" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon" :disabled="indDateDisable"></date-picker>
                                            <label for="base_index_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{base_index_date_error_msg}}</div>
                                    </div>
                                    <!--div class="col form-group" v-if="contract_id != null && contract_id != ''">
                                        <label class="control-label" for="discount_fixed">Discount for Fixed Rate:</label>
                                        <v-select v-model="discount_fixed" name="discount_fixed"
                                            label="text" :filterable="false" :options="discountsArr"
                                            placeholder="Select Discount" class="custom-ci-auto-search">
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ discount_fixed_error_msg }}</div>
                                    </div>

                                    <div class="col form-group" v-if="contract_id != null && contract_id != ''">
                                        <label class="control-label" for="discount_variable">Discount for Variable Rate:</label>
                                        <v-select v-model="discount_variable" name="discount_variable"
                                            label="text" :filterable="false" :options="discountsArr"
                                            placeholder="Select Discount" class="custom-ci-auto-search">
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ discount_variable_error_msg }}</div>
                                    </div-->

                                </div>


                                <div class="form-row row-cols-md-4 row-cols-1" v-if="!cpi_waived">
                                    <div class="col form-group" v-if="next_escalation_date != ''">
                                        <label class="control-label">Next Escalation Date :</label>
                                        <span class="label">{{next_escalation_date}}</span>
                                    </div>
                                    <!-- <div class="col form-group" v-if="base_index_date != ''">
                                        <label class="control-label">Base Index Date :</label>
                                        <span class="label">{{base_index_date}}</span>
                                    </div> -->
                                    <div class="col form-group" v-if="base_index_value != ''">
                                        <label class="control-label">Base Index : </label>
                                        <span class="label">{{base_index_value}}</span>
                                    </div>
                                    <template v-if="fuelTank != '' && fuelTank.value">
                                        <div class="col form-group">
                                            <label class="control-label">{{fuelTank.text}} :</label>
                                            <span class="label">{{fuelTank.value}}</span>
                                        </div>
                                    </template>
                                    <template v-if="defTank != '' && defTank.value">
                                        <div class="col form-group">
                                            <label class="control-label">{{defTank.text}} :</label>
                                            <span class="label">{{defTank.value}}</span>
                                        </div>
                                    </template>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="alert-contract error hide"></div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateContractAssetDetailBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateContractAssetDetail" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateContractAssetDetailBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateContractAssetDetail" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueContractAssetDetailBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateContractAssetDetail(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelContractAssetDetailBtn" class="btn btn-tertiary" v-on:click.prevent="BackContractAssetDetailList" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


import moment from 'moment';


export default {
  name: "ContractAssetDetailCreate",

  metaInfo() {
      return {
         title: (this.$route.params.id > 0)? "Update Contract Asset  | " +process.env.COPYRIGHT_NAME : "Create Contract Asset | " +process.env.COPYRIGHT_NAME
      }
  },
  mixins:[commonMixins],
  data: () => ({
    discountsArr: [],
    discount_fixed: '',
    discount_fixed_error_msg: "",
    discount_variable: '',
    discount_variable_error_msg: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    permissions: [],
    editExpiryDate:true,
    cantAccessPage: "",
    vehicle_id: null,
    vehicleArr: [],
    contract_id: null,
    contractArr: [],
    reservationArr:[],
    term: "",
    reservation_id:"",
    effective_date: "",
    expiry_date: "",
    loading:false,
    // term_error_msg: "",
    vehicle_error_msg: "",
    contract_error_msg: "",
    effective_date_error_msg: "",
    base_index_date_error_msg:"",
    expiry_date_error_msg: "",
    sectionTypes:[],
    sectionratesArr: [],
    section_id: "",
    section_value: "",
    section_rates_error_msg: "",
    cpi_increase_percent: "",
    cpi_rates_error_msg: "",
    rate_increase_percent: "",
    rate_error_msg: "",
    limit_percent: "",
    limit_error_msg: "",
    reservationerror:"",
    id_update: "", //Section Auto Increment ID
    blockRemoval: true,
    close:false,
    readInArr:[],
    optionsDateTime:{
        format: 'MM/DD/YYYY HH:mm:ss',
        useCurrent: true,
    },
    unitArr:[],
    defTank:'',
    fuelTank:'',
    first_escalation_date:'',
    firstEscalationRequired:"require",
    next_escalation_date:'',
    base_index_date:'',
    base_index_value:'',
    first_escalation_date_error_msg:'',
    excess_mileage_variation_error_msg:'',
    allow_substitute:false,
    // variation_allowed:false,
    cpi_waived:false,
    poArr:[],
    po:'',
    customer_po_error_msg:'',
    unit_no:'',
    schedule_original_value:'',
    schedule_depreciation:'',
    contractAssetId:"",
    copyContractAssStatus:"",
    assetDetail: null,
    isEdit: false,
    customerArr:[],
    customer_id:"",
    customer_error_msg:"",
    residual:'',
    exmilevariation:'',
    fromUrl:"",
    old_expiry:'',
    indDateDisable:false
  }),
  watch:{

        // //update next escalation date on change first escalation date value
        // first_escalation_date: function(date) {
        //     var self = this;
        //     if ( date != "" ) {

        //         var efDate = this.effective_date;

        //         if(self.contract_id.frequency && self.contract_id.frequency != ''){

        //             var dateEsc = moment(self.first_escalation_date, "MM/DD/YYYY")
        //                     .add(self.contract_id.frequency,'month') //add frequency to calculate next escalation date

        //             self.next_escalation_date = moment(dateEsc).format('MM/DD/YYYY');
        //         }


        //     } else {

        //         //only applicabale if CPI waived is false
        //         if ( !self.cpi_waived ) {

        //             var dateEsc = moment(self.first_escalation_date, "MM/DD/YYYY")
        //                     .add(self.contract_id.frequency,'month') //add frequency to calculate next escalation date

        //             self.next_escalation_date = moment(dateEsc).format('MM/DD/YYYY');
        //         }

        //     }

        // },
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_contract_asset_detail' ) {
                        self.cantAccessPage = true;

                    }
                }
            }

        },
        //if click on edit button and change contract id empty all data of contract asset details add page.
        contract_id: function(contract_id,oldId) {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            // if (!segments[3]){
            //     if (self.contract_id.effective_date){
            //         self.effective_date = self.contract_id.effective_date;
            //     }
            //     if (self.contract_id.term){
            //         self.term = self.contract_id.term;
            //     }
            // }
            // console.log(contract_id);
            console.log(self.contract_id);
            if(self.contract_id != null) {
              if(!self.isEdit) {
                self.discount_fixed = '';
                self.discount_variable = '';
              }
            //   self.getDiscounts();
            } else {

            }
            $(".alert-contract").empty();
            if(contract_id.termination_date != null){
                $(".alert-contract").append("<ul><li> Selected Constract will going to terminated on "+contract_id.termination_date+" </li></ul>");
                $(".alert-contract").addClass("show");
                $(".alert-contract").removeClass("hide");
            }else{
                $(".alert-contract").removeClass("show");
                $(".alert-contract").addClass("hide");
            }


            //empty contract asset value on contract change, oldId will give previously selected contract id
            if(self.contract_id != null && oldId != null){
                console.log("Inside Watch Contract Id")
                if(self.contract_id.value != oldId.value && self.$route.params.id == undefined ){
                    self.vehicle_id = "";

                }
            }
            if(self.contract_id == null){

                self.vehicle_id = "";
                self.discount_fixed = "";
                self.discount_fixed_error_msg = "";
                self.discount_variable = "";
                self.discount_variable_error_msg = "";
                self.vehicleArr = [];
                self.discountsArr = [];
                self.sectionratesArr = [];
                self.effective_date = "";
                self.base_index_date = "";
                // self.term = "";
                self.expiry_date = "";
            }

            if ( self.vehicle_id != null && self.vehicle_id.value != undefined ) {

                var contract_type_id = self.contract_id.contract_type_id;
                var vehicle_type_id = self.vehicle_id.vehicle_type_id;
            }

        },
        vehicle_id: function(vehicle_id) {
          console.log(vehicle_id);

            var self = this;
            console.log(self.vehicle_id);
            console.log("CUSTOMER ==", self.contract_id);

            var customer = "";
            if(self.customer_id != null && self.customer_id != "") {
                customer = self.customer_id.value;
            }

            if (self.vehicle_id == null || self.vehicle_id.value == undefined) {
                return;
            }
            $.ajax({
                url: process.env.ROOT_API + "/asset/"+vehicle_id.value,
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                data: {
                  customer_id : customer,
                },
                success: function (data) {
                    //if data is edit than dont make model id blank
                    if (data.status == "success") {
                        self.assetDetail = data.content;
                        var extra_features = data.content.extra_features;
                        self.defTank = '';
                        self.fuelTank = '';
                        if (extra_features != null && extra_features.length){
                            extra_features.forEach(function(val){

                                if (val.text == 'DEF | DEF TANK'){
                                    self.defTank = val;
                                }
                                if (val.text == 'FTT | FUEL TANK (TOTAL GALS)'){
                                    self.fuelTank = val;
                                }
                            })
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'asset-data')
                }
            });
        },
        sectionratesArr() {
            var self = this;
            self.blockRemoval = self.sectionratesArr.length <= 1
        },
        // term: function(contract_term) {
        //     if ( contract_term != "" && contract_term > 0) {
        //         var efDate = this.effective_date;
        //         // if ( efDate != "" ) {

        //         //     var effDate = new Date(efDate);
        //         //     console.log("month",effDate.getMonth() + 1 );
        //         //     effDate.setMonth(effDate.getMonth() + parseInt(contract_term));

        //         //     this.expiry_date = ('0' + (effDate.getMonth() + 1)).slice(-2) + "/" + ('0' + effDate.getDate()).slice(-2) + "/" + effDate.getFullYear();

        //         // } else {
        //         //     this.expiry_date = "";
        //         // }


        //         if (contract_term != null && contract_term != '' && efDate != ''){
        //             // var dt = new Date(self.start_date);
        //             var days = moment(efDate).format('DD');

        //             this.expiry_date = moment(efDate).add(contract_term, 'months').format('MM/DD/YYYY');
        //             // self.last_date = self.addMonths(dt,val);
        //             // self.expiry_date = moment(self.last_date).format('MM/DD/YYYY');
        //             // self.getLastDateofmonth();
        //         }
        //     } else {
        //     }

        // },
        // expiry_date:function(date){
        //     var self = this;
        //     if (date != '' && date != undefined){
        //         var term = self.monthDiff(new Date(self.effective_date),new Date(self.expiry_date));
        //         if (term > 0){
        //             self.term = term;
        //         }
        //     }
        // },
        assetDetail: function (assetDetail) {
          var self = this;
          if(self.assetDetail == null || self.assetDetail == "") {
            self.vehicle_error_msg = "";
            return;
          }
          if (self.assetDetail.deposit_required > 0 && self.assetDetail.deposit_required > self.assetDetail.customer_remain_deposit) {
            self.vehicle_error_msg = "Sufficient Deposit not found. Please contact the AR team.";
          }
        }
    },
    created: function() {
    },
    beforeRouteLeave(to, from, next) {
        var self = this;
        self.left_view_edit_channel(from.fullPath);
        next();
    },
    mounted: function() {
        var self = this;

        self.getPermissions();
        self.getSectionTypes();

        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            self.contractAssetId = segments[3];
            self.loadContractAssetDetail();

            //Join ViewEdit Channel
            self.join_view_edit_channel(segments[1],segments[2],segments[3]);

        }
        if(self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined){
          self.fromUrl = atob(self.$route.query.fromUrl);
        }
        if (self.$route.query.batch != undefined && self.$route.query.batch != '' && self.$route.query.id != undefined){
            self.contractAssetId = self.$route.query.id;
            if (self.$route.query.old_expiry != undefined){
                self.old_expiry = self.$route.query.old_expiry;
            }
            self.loadContractAssetDetail();
        }
        if (self.$route.query.from && self.$route.query.from == 'return'){
            self.close = true;
            // self.getSection('return');
        } else if (self.$route.query.data && self.$route.query.data != '') {

            var webloc = window.location.href;
            var decodeStr = atob(this.$route.query.data);
            var url = new URL(webloc+"?"+decodeStr);
            var copyContractAssId = url.searchParams.get("contractAssetId");
            self.copyContractAssStatus = url.searchParams.get("contractAssetStatus");
            self.contractAssetId = copyContractAssId;
            self.loadContractAssetDetail();

        } else {

            if (!segments[3]) {
                // self.unitArr.push({
                //     section_id:null,
                //     section_error_msg:'',
                //     reading_out:'',
                //     reading_out_error_msg:'',
                //     reading_out_date:'',
                //     reading_out_date_error_msg:'',
                // });
            }
        }
        var contractName = self.$route.query.contractName;
        var contractId = self.$route.query.contractId;
        var contractTypeId = self.$route.query.contractTypeId;
        var contractTypeCode = self.$route.query.contractTypeCode;
        var customerId = self.$route.query.customerId;
        var customerName = self.$route.query.customerName;
        var customerCode = self.$route.query.customerCode;
        if (contractTypeCode !== undefined) {
            contractTypeCode = decodeURIComponent(contractTypeCode.replace(/\+/g, ' '));
            var matches = contractTypeCode.match(/\(([^())]+)\)/);

            if (matches !== null && matches.length > 1) {
                contractTypeCode = matches[1];
            } else {
                contractTypeCode = '';
            }
        }

        if(contractId) {
            $("#contract_id").addClass('js-example-disabled');
            self.contract_id = {value: contractId, text: contractName+" ("+contractTypeCode+")", contract_type_id: contractTypeId, customer_id:customerId};
        }
        if (customerId != undefined) {
            if (customerCode != undefined && customerCode != null) {
                self.customerSubAccounts(customerCode);
                var customerText = customerCode;
                if (customerName != undefined && customerName != null) {
                    customerText += " | ";
                    customerText += customerName;
                }
                self.customer_id = {text:customerText,value:customerId};
            }
        }


  },
  methods: {
        onChangeExpiry:function(date){
            var self = this;
            if (date != '' && date != undefined){
                var term = self.monthDiff(new Date(self.effective_date),new Date(self.expiry_date));
                if (term > 0){
                    self.term = term;
                }
            }
        },
        onChangeTerm: function(contract_term) {
            if ( contract_term != "" && contract_term > 0) {
                var efDate = this.effective_date;
                // if ( efDate != "" ) {

                //     var effDate = new Date(efDate);
                //     console.log("month",effDate.getMonth() + 1 );
                //     effDate.setMonth(effDate.getMonth() + parseInt(contract_term));

                //     this.expiry_date = ('0' + (effDate.getMonth() + 1)).slice(-2) + "/" + ('0' + effDate.getDate()).slice(-2) + "/" + effDate.getFullYear();

                // } else {
                //     this.expiry_date = "";
                // }


                if (contract_term != null && contract_term != '' && efDate != ''){
                    // var dt = new Date(self.start_date);
                    var days = moment(efDate).format('DD');

                    this.expiry_date = moment(efDate).add(contract_term, 'months').format('MM/DD/YYYY');
                    // self.last_date = self.addMonths(dt,val);
                    // self.expiry_date = moment(self.last_date).format('MM/DD/YYYY');
                    // self.getLastDateofmonth();
                }
            } else {
            }

        },
        //update next escalation date on change first escalation date value
        onChangeFirstEsc: function(date) {
            var self = this;
            if ( date != "" ) {
                var efDate = this.effective_date;

                if(self.contract_id != null && self.contract_id.frequency && self.contract_id.frequency != ''){

                    var dateEsc = moment(self.first_escalation_date, "MM/DD/YYYY")
                            .add(self.contract_id.frequency,'month') //add frequency to calculate next escalation date

                    self.next_escalation_date = moment(dateEsc).format('MM/DD/YYYY');
                }


            } else {

                //only applicabale if CPI waived is false
                if ( !self.cpi_waived ) {

                    var dateEsc = moment(self.first_escalation_date, "MM/DD/YYYY")
                            .add(self.contract_id.frequency,'month') //add frequency to calculate next escalation date

                    self.next_escalation_date = moment(dateEsc).format('MM/DD/YYYY');
                }

            }

        },
    //update expiry date on change effective value
        changeEffectiveDate: function(effDate) {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.contract_error_msg = "";
            if ( effDate != "" && effDate != null) {

                // if ( self.contract_id != null && self.contract_id.value != undefined ) {

                    // if (!segments[3]) {
                        // self.getCPIDetails();
                    // }
                // } else {
                //     self.contract_error_msg = 'Please Select any contract';
                // }
                var term = this.term;
                if ( term != "" && term > 0) {

                    // var effDate = new Date(effDate);
                    // console.log("month",effDate.getMonth() + 1 );
                    // effDate.setMonth(effDate.getMonth() + parseInt(term));

                    // this.expiry_date = ('0' + (effDate.getMonth() + 1)).slice(-2) + "/" + ('0' + effDate.getDate()).slice(-2) + "/" + effDate.getFullYear();
                    this.expiry_date = moment(effDate).add(term, 'months').format('MM/DD/YYYY');
                } else {
                    if (term > 0){

                        this.expiry_date = "";

                    }
                }

            }
            self.onChangeFirstEsc(self.first_escalation_date)

        },
         //remove first escaltion date if CPI waived is changed to false
        cpi_waived_change: function(isWaived) {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            if ( isWaived ) {
                this.first_escalation_date = "";
                self.firstEscalationRequired = "";
            } else {
                if ( self.contract_id.value != undefined ) {
                    if (!segments[3]) {
                        // self.getCPIDetails();
                    }
                } else {
                    self.contract_error_msg = 'Please Select any contract';
                }
                self.firstEscalationRequired = "require";
            }

        },
    getDiscounts() {
      var self = this;
      self.loading=true;
      $.ajax({
          url: process.env.ROOT_API + "/contract/discounts",
          type: "POST",
          data: {"contract_id":self.contract_id.value},
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
              self.loading = false;

              if (data.status == "success") {
                  self.loading=false;
                  self.discountsArr = data.content.discounts;
              }
          },
          error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
          }
      });
    },
    changeAssetsSelection(vehicle) {
      var self = this;
      if(self.vehicle == null || self.vehicle == "" || self.assetDetail == null || self.assetDetail == "") {
        self.vehicle_error_msg = "";
        return;
      }
    },
    // enterVal:function(evt, type) {
    //   evt = (evt) ? evt : window.event;
    //   // console.log("ENTER  ==", evt.target.value);
    //   // this.unit_price = evt.target.value;
    //   // this.unit_price = evt.target.value.replace(/\,/g,"");
    //   if(type == 'original') {
    //     this.schedule_original_value = evt.target.value;
    //     this.schedule_original_value = evt.target.value.replace(/\,/g,"");
    //   } else {
    //     this.schedule_depreciation = evt.target.value;
    //     this.schedule_depreciation = evt.target.value.replace(/\,/g,"");
    //   }
    // },
    // leaveFocus:function(evt, type) {
    //     evt = (evt) ? evt : window.event;
    //     console.log("focus ==", evt.target.value);
    //     if(type == 'original') {
    //       this.schedule_original_value = this.amountFormat(evt.target.value);
    //     } else {
    //       this.schedule_depreciation = this.amountFormat(evt.target.value);
    //     }
    //     // this.unit_price = this.amountFormat(evt.target.value);
    // },
      amountFormat(amount) {
          const formatter = new Intl.NumberFormat('en-US', {
              minimumFractionDigits:2,
              maximumFractionDigits:2
          });

          return formatter.format(amount);
      },


    /* get section rate for contract type id and asset type id.*/
    getSectionTypes(){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/contracttype/getsectionrate",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.sectionTypes = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate')
            }
        });
    },
    getCPIDetails(flag){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/cpi/detail",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                contract_id:self.contract_id.value,
                effective_date: (flag == "base_index_date") ? self.base_index_date : self.effective_date
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    if (!self.cpi_waived && flag == "base_index_date"){
                        self.next_escalation_date = data.content.next_escalation_date;
                        self.base_index_value = data.content.base_index_value;
                    }else if(!self.cpi_waived && flag == "effective_date"){
                      self.first_escalation_date = data.content.first_escalation_date;
                    }

                    // self.sectionTypes = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate')
            }
        });
    },

    onSearchVehicle(search, loading) {
        var self = this;
        console.log(self.contract_id);
        if (search.length > 3) {

            var contractID = self.contract_id.value;
            if ( contractID == undefined ) {
                alert("please select Contract first");
                return;
            }

            loading(true);
            self.searchField(loading, search, 'lease vehicle', self.contract_id.value);
        }

    },

    onSearchPO(search, loading) {
        var self = this;
        if(self.contract_id == null){

            self.contract_error_msg = 'Contract require to search PO';
        }else{

            self.contract_error_msg = "";
        }
        if (search.length > 0 && self.customer_id != null && self.customer_id != "" && self.customer_id.value) {
            // loading(true);

            self.searchPo(search,self.customer_id.value);
        }

    },
    searchPo(searchValue,custId){

        var self = this;

        // self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/cust-po/search",
            type: "POST",
            headers: this.ajxHeaders,
            data: {
                customer_id:custId,
                search:searchValue
            },
            dataType : "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    console.log(data.content);
                    self.poArr = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-search-po')
            }
        });
    },


    onSearchContract(search, loading) {
        var self = this;
        if (search.length > 0) {

            loading(true);
            self.searchField(loading, search, 'contract', '');
        }
    },



    BackContractAssetDetailList() {
      var self = this;
      var url = "/contractassetdetail/list";
      if ( self.fromUrl != "" && self.fromUrl != undefined ) {
        url = self.fromUrl;
      }
      self.redirectPageUrl(url);
    },

    CreateContractAssetDetail(flag) {
      var self = this;
      var error = false;

    //   self.term_error_msg = "";
      self.contract_error_msg = "";
      self.vehicle_error_msg = "";
      self.effective_date_error_msg = "";
      self.base_index_date_error_msg = "";
      self.expiry_date_error_msg = "";
      self.first_escalation_date_error_msg = "";
      self.excess_mileage_variation_error_msg = "";
      self.customer_error_msg = "";
      var sectionArr = [];

    //   if (!self.term || self.term == null || self.term == "") {
    //     self.term_error_msg = "Term require.";
    //     error = true;
    //   }

        //if cpi waived not selected
        if ( !self.cpi_waived ) {
            if (!self.first_escalation_date || self.first_escalation_date == null || self.first_escalation_date == "") {
                self.first_escalation_date_error_msg = "First Escalation Date require.";
                error = true;
            }
            if (!self.base_index_date || self.base_index_date == null || self.base_index_date == "") {
                self.base_index_date_error_msg = "Base Index Date require.";
                error = true;
            }
        }

      if (self.exmilevariation > 100 && self.exmilevariation != null) {
        self.excess_mileage_variation_error_msg = "Excess Mileage Variation should not be greater than 100%.";
        error = true;
      }
      if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
        self.effective_date_error_msg = "Effective Date require.";
        error = true;
      }

      if (!self.expiry_date || self.expiry_date == null || self.expiry_date == "") {
        self.expiry_date_error_msg = "Expiry Date require.";
        error = true;
      }

      if (self.contract_id == null || !self.contract_id.value) {
        self.contract_error_msg = "Contract Name require.";
        error = true;
      }
      if (self.customer_id == null || !self.customer_id.value) {
        self.customer_error_msg = "Customer require.";
        error = true;
      }
      if (self.vehicle_id == null || !self.vehicle_id.value) {
        self.vehicle_error_msg = "Asset Name require.";
        error = true;
      }
      if (self.assetDetail != null && self.assetDetail.deposit_required > 0 && self.assetDetail.deposit_required > self.assetDetail.customer_remain_deposit) {
        self.vehicle_error_msg = "Sufficient Deposit not found. Please contact the AR team.";
        error = true;
      }



      if (Date.parse(self.effective_date) > Date.parse(self.expiry_date)) {
        alert("Expiry Date should not be earlier than Effective Date");
        error = true;
      }

      var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

      if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateContractAssetDetailBtn").val("Updating ...");
                $("#CreateContractAssetDetailBtn").prop("disabled", true);
                $("#cancelContractAssetDetailBtn").prop("disabled",true);

            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueContractAssetDetailBtn").val("Saving ...");
                    $("#CreateContractAssetDetailBtn").prop("disabled", true);
                    $("#createAndContinueContractAssetDetailBtn").prop("disabled", true);
                    $("#cancelContractAssetDetailBtn").prop("disabled",true);

                }else{

                    $("#CreateContractAssetDetailBtn").val("Saving ...");
                    $("#CreateContractAssetDetailBtn").prop("disabled", true);
                    $("#createAndContinueContractAssetDetailBtn").prop("disabled", true);
                    $("#cancelContractAssetDetailBtn").prop("disabled",true);
                }

            }

            var fields = $("#ContractAssetDetailForm").serializeArray();
            var idx = fields.findIndex(obj => obj.name == 'schedule_original_value');
            if (idx != -1) {
              fields.push({
                  name: "schedule_original_value",
                  value: fields[idx].value.replace(/\,/g,"")
              });
              fields.splice(idx, 1);
            }
            var idx1 = fields.findIndex(obj => obj.name == 'schedule_depreciation');
            if (idx1 != -1) {
              fields.push({
                  name: "schedule_depreciation",
                  value: fields[idx1].value.replace(/\,/g,"")
              });
              fields.splice(idx1, 1);
            }


            fields.push({name: "contract_id", value: self.contract_id.value});
            fields.push({name: "customer_id", value: self.customer_id.value});
            fields.push({name: "vehicle_id", value: self.vehicle_id.value});
            fields.push({name: "first_escalation_date", value: self.first_escalation_date});
            fields.push({name: "next_escalation_date", value: self.next_escalation_date});
            fields.push({name: "base_index_date", value: self.base_index_date});
            fields.push({name: "base_index_value", value: self.base_index_value});
            if (self.po != null && self.po.value){

                fields.push({name: "po", value: self.po.value});

            }else{

                fields.push({name: "po", value: ''});

            }
            if ( self.allow_substitute == true ) {
                fields.push({name: "allow_substitute", value: 1});
            }else{
                fields.push({name: "allow_substitute", value: 0});
            }
            // if ( self.variation_allowed == true ) {
            //     fields.push({name: "variation_allowed", value: 1});
            // }else{
            //     fields.push({name: "variation_allowed", value: 0});
            // }
            if ( self.cpi_waived == true ) {
                fields.push({name: "cpi_waived", value: 1});
            }else{
                fields.push({name: "cpi_waived", value: 0});
            }

            fields.push({name: "id", value: segments[3]});

            if (self.close == true){

                fields.push({name: "reading_in", value: JSON.stringify(self.readInArr)});
                fields.push({name: "effective_date", value: self.effective_date});


            }else{

                fields.push({name: "reading_out", value: JSON.stringify(self.unitArr)});
            }
            if (self.reservation_id != null && self.reservation_id != ''
            && self.reservation_id.value){
                fields.push({name: "reservation_id", value: self.reservation_id.value});
            }else{
                fields.push({name: "reservation_id", value: ''});
            }

            // if(self.discount_fixed != null && self.discount_fixed != '' && self.discount_fixed.id) {
            //   fields.push({name: "discount_fixed", value: self.discount_fixed.id});
            // } else {
            //   fields.push({name: "discount_fixed", value: ''});
            // }
            // if(self.discount_variable != null && self.discount_variable != '' && self.discount_variable.id) {
            //   fields.push({name: "discount_variable", value: self.discount_variable.id});
            // } else {
            //   fields.push({name: "discount_variable", value: ''});
            // }
            if (self.$route.query.batch != undefined && self.$route.query.batch != '' && self.$route.query.id != undefined){
                fields.push({name: "batch", value: self.$route.query.batch});
                fields.push({name: "cur_id", value: self.$route.query.id});
            }

            console.log(fields);//return;
            $.ajax({
                url: process.env.ROOT_API + "/contractassetdetail/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateContractAssetDetailBtn").val("Update");
                        $("#CreateContractAssetDetailBtn").prop("disabled", false);
                        $("#cancelContractAssetDetailBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractAssetDetailBtn").val("Save and Continue");
                            $("#CreateContractAssetDetailBtn").prop("disabled", false);
                            $("#createAndContinueContractAssetDetailBtn").prop("disabled", false);
                            $("#cancelContractAssetDetailBtn").prop("disabled",false);

                        }else{

                            $("#CreateContractAssetDetailBtn").val("Save");
                            $("#CreateContractAssetDetailBtn").prop("disabled", false);
                            $("#createAndContinueContractAssetDetailBtn").prop("disabled", false);
                            $("#cancelContractAssetDetailBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {
                        if (data.content.next_id != undefined && data.content.next_id > 0){
                            self.$router.push('/contractassetdetail/view/'+data.content.next_id+'?batch='+self.$route.query.batch);
                            return;
                        }
                        if (flag == "Save and Continue") {

                            $("#ContractAssetDetailForm").trigger("reset");
                            self.term ="";
                            // self.contract_id = null;
                            self.vehicle_id = null;
                            self.effective_date = "";
                            self.expiry_date = "";
                            // self.customer_id = null;
                            self.residual = '';
                            self.exmilevariation = '';
                            self.next_escalation_date = '';
                            self.first_escalation_date = '';
                            self.base_index_date = '';
                            self.base_index_value = '';

                        }else{
                            self.$router.push("/contractassetdetail/view/"+data.content.id);
                        }
                        $(".alert-contract").empty();
                        $(".alert-contract").removeClass("show");
                        $(".alert-contract").addClass("hide");

                    } else {
                        if (data.content.length > 0) {
                            var err = "<ul>";
                            $(".alert-contract").empty();

                            for (var i = 0; i < data.content.length; i++) {
                                err += "<li>" + data.content[i] + "</li>";
                            }
                            err += "</ul>";
                            $(".alert-contract").append(err);
                            $(".alert-contract").addClass("show");

                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateContractAssetDetailBtn").val("Update");
                        $("#CreateContractAssetDetailBtn").prop("disabled", false);
                        $("#cancelContractAssetDetailBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractAssetDetailBtn").val("Save and Continue");
                            $("#CreateContractAssetDetailBtn").prop("disabled", false);
                            $("#createAndContinueContractAssetDetailBtn").prop("disabled", false);
                            $("#cancelContractAssetDetailBtn").prop("disabled",false);

                        }else{

                            $("#CreateContractAssetDetailBtn").val("Save");
                            $("#CreateContractAssetDetailBtn").prop("disabled", false);
                            $("#createAndContinueContractAssetDetailBtn").prop("disabled", false);
                            $("#cancelContractAssetDetailBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'contract-asset-detail-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }

    },
    onSearchReservation(search, loading) {
      var self = this;
        if (self.vehicle_id == null || !self.vehicle_id.value) {

        }else{
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'lease_reservation', self.vehicle_id.value);
            }
        }

    },
    getSection: function(flag){
        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/getcontractsection",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                id:self.$route.params.id
            },
            dataType: "json",
            success: function (data) {

                self.loading = false;
                if (data.status == "success") {
                    if (data.content && data.content.length > 0){

                        for (var i = 0; i < data.content.length; i++) {

                            self.readInArr.push({
                                section_id:data.content[i].section_id,
                                section:data.content[i].section,
                                reading_in:'',
                                reading_in_error_msg:'',
                                reading_in_date:'',
                                reading_in_date_error_msg:'',
                            });
                        }

                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'contract-asset-detail-load')
            }
        });

    },
    loadContractAssetDetail() {

        var self = this;
        var batch = '';
        if(self.$route.query.batch != undefined && self.$route.query.batch != ''){
            batch = self.$route.query.batch;
        }
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/contractassetdetail/" + self.contractAssetId,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                batch:batch,
                old_expiry:self.old_expiry,
                action_flag : 'edit', // pass action for notify: view, edit
                is_notify_flag : true // notify if user viewing or editing
            },
            success: function (data) {

                self.loading = false;
                if (data.status == "success") {
                  self.isEdit = true;

                  // console.log("MY DSCNT == ", data.content.discount);

                    self.term = data.content.term;

                    if (data.content.allow_substitute == 1){
                        self.allow_substitute = true;
                    }else{
                        self.allow_substitute = false;
                    }
                    // if (data.content.variation_allowed == 1){
                    //     self.variation_allowed = true;
                    // }else{
                    //     self.variation_allowed = false;
                    // }
                    if (data.content.cpi_waived == 1){
                        self.cpi_waived = true;
                    }else{
                        self.cpi_waived = false;
                    }
                    if (self.$route.query.batch != undefined && self.$route.query.batch != ''){}else{
                        self.contract_id = {value: data.content.contract_id, text: data.content.contName + " (" +  data.content.ctCode + ") ",customer:data.content.customer_id,frequency:data.content.frequency};
                        self.customer_id = {value: data.content.customer_id, text: data.content.cust_code + " | " + data.content.cust_name};
                        self.customerSubAccounts(data.content.cust_code);//customer sub accounts
                    }

                    self.schedule_original_value = self.amountFormat(data.content.schedule_original_value);
                    self.schedule_depreciation = self.amountFormat(data.content.schedule_depreciation);

                    //don't load field if copycontract set
                    if ( self.copyContractAssStatus == "" ) {

                        self.effective_date = data.content.effective_date;
                        self.expiry_date = data.content.expiry_date;

                        // set min and max date for start and end date as some time its not called...
                        if ( self.expiry_date != "" && self.expiry_date != null ) {
                            self.$set(self.fromOptionsDate, 'maxDate', moment(self.expiry_date,"MM/DD/YYYY"));
                        }
                        self.$set(self.toOptionsDate, 'minDate', moment(self.effective_date,"MM/DD/YYYY"));

                        setTimeout(function(){
                            self.first_escalation_date = data.content.first_escalation_date;
                        },2000);

                        if ( data.content.cust_purchase_order ) {
                            self.po = {value: data.content.cust_purchase_order, text: data.content.po_no + " | " +  data.content.po_total};
                        }
                    }

                    //handle copy contract asset if copied contract asset is active or pending asset will not populate
                    if ( self.copyContractAssStatus == "" || self.copyContractAssStatus == "Closed" ) {

                        self.unit_no = data.content.cust_unit_no;
                        if(data.content.vehicle_id != null){
                            var vehicleData = self.titleCase(data.content.vmUnitNo);
                            if(data.content.vtCode != null){
                                vehicleData += " | " + self.titleCase(data.content.vtCode);
                            }
                            if(data.content.vmName != null){
                                vehicleData += " | " + self.titleCase(data.content.vmName);
                            }
                            self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                        }else{
                            self.vehicle_id = null;
                        }
                    }

                    self.reservation_id = {value: data.content.rsv_id, text: data.content.reference_no};

                    if (data.content.readingOut && data.content.readingOut.length > 0){
                        for (var i = 0; i < data.content.readingOut.length; i++) {

                            self.unitArr.push({
                                section_id:{text:data.content.readingOut[i].section,value:data.content.readingOut[i].section_id},
                                reading_out:data.content.readingOut[i].reading_out,
                                reading_out_error_msg:'',
                                reading_out_date:data.content.readingOut[i].reading_date,
                                reading_out_date_error_msg:'',
                            });
                        }
                    }
                    if (self.close){
                        if (data.content.readingOut && data.content.readingOut.length > 0){
                            for (var i = 0; i < data.content.readingOut.length; i++) {

                                self.readInArr.push({
                                    section_id:data.content.readingOut[i].section_id,
                                    section:data.content.readingOut[i].section,
                                    reading_in:'',
                                    reading_in_error_msg:'',
                                    reading_in_date:'',
                                    reading_in_date_error_msg:'',
                                });
                            }
                        }
                    }

                    data.content.discount.forEach(element => {
                      if(element.applied_for == "FIXED RATE") {
                        self.discount_fixed = element;
                      } else if(element.applied_for == "VARIABLE RATE") {
                        self.discount_variable = element;
                      }

                    });

                    self.residual = data.content.residual;
                    self.exmilevariation = data.content.ex_mile_variation;
                    self.discount = data.content.discount;

                    self.first_escalation_date = data.content.first_escalation_date;
                    self.next_escalation_date = data.content.next_escalation_date;
                    self.base_index_date = data.content.base_index_date;
                    self.base_index_value = data.content.base_index_value;

                    if (new Date(self.first_escalation_date) < new Date()){
                        self.indDateDisable = true;
                    }

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'contract-asset-detail-load')
            }
        });
    },
    monthDiff(d1, d2) {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
    },
    customerSubAccounts(custCode) {
        var self = this;
        if (custCode != "") {
            $.ajax({
                url: process.env.ROOT_API + "/customer/sub-accounts",
                type: "POST",
                headers: this.ajxHeaders,
                data:{code:custCode},
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (data.status == "success") {
                        self.customerArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'customer-sub-accounts')
                }
            });
        }
    },
    onContractSelect() {
        var self = this;
        if (self.contract_id != null) {
            if (self.contract_id.customer_code != undefined) {
                if (self.contract_id.customer_code != null) {
                    self.customer_id = {value:self.contract_id.customer,text:self.contract_id.customer_name};
                    self.customerSubAccounts(self.contract_id.customer_code);
                }
            }
        }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContractAssetDetailCreate.vue